'use strict';

var useFormValidation = require('./useFormValidation.js');
var validationErrors = require('./validationErrors.js');
var classValidator = require('class-validator');
var fieldMetadata = require('./fieldMetadata.js');
require('./_chunks/tslib.es6-DSduP8Mp.js');
require('react');
require('./validationState.js');
require('@templafy/translation');
require('./keys.js');
require('./validationPointers.js');



exports.useFormValidation = useFormValidation.useFormValidation;
exports.isValidationError = validationErrors.isValidationError;
Object.defineProperty(exports, "validate", {
	enumerable: true,
	get: function () { return classValidator.validate; }
});
Object.defineProperty(exports, "validateSync", {
	enumerable: true,
	get: function () { return classValidator.validateSync; }
});
exports.convertValuesToClass = fieldMetadata.convertValuesToClass;
//# sourceMappingURL=index.js.map
